module.exports = __webpack_public_path__ + "img/logo.fdfc8b1a.svg";